import React, { FC } from 'react';

import { AgeRestrictionContainer } from '@/scenarios/legacy-player/components/feature-player/ui/skin/age-restriction/container';

import { useChannelAgeRestrictionData } from '../../hooks/use-channel-age-restriction-data';

interface ChannelAgeRestrictionProps {
    contentId: string;
}

export const ChannelAgeRestriction: FC<ChannelAgeRestrictionProps> = ({ contentId }) => {
    const stateProps = useChannelAgeRestrictionData(contentId);

    return <AgeRestrictionContainer {...stateProps} />;
};
